"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var memoize = require("fast-memoize");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var translate_1 = require("utils/translate");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var ssoActions = require("@caddigital/sok-reducers/lib/actions/sso");
var sok_ui_1 = require("@caddigital/sok-ui");
var components_1 = require("components");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var avatars_1 = require("components/Avatar/avatars");
var Types = require("types");
var text_1 = require("utils/text");
var AttachCompanyModal_1 = require("./AttachCompanyModal");
var ManageUsersModal_1 = require("./ManageUsersModal");
var DomainsModal_1 = require("./DomainsModal");
require("./styles.scss");
var headers = ['id', 'name', 'domains'];
function getDomains(domains) {
    return (domains || []).join(', ');
}
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        selectedLanguage: selectedLanguage,
        viewportSize: state.viewport.size,
        management: state.sso.management
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchFederation: function (federation) {
        return dispatch(ssoActions.fetchManagementCurrentRequest(federation));
    },
    fetchCompanies: function (federation) {
        return dispatch(ssoActions.fetchManagementCompanyListRequest(federation));
    },
    fetchClients: function () { return dispatch(ssoActions.fetchManagementClientListRequest()); },
    fetchUsers: function (sso, filter) {
        return dispatch(ssoActions.listUsersRequest(sso, filter));
    },
    convertUsers: function (sso, users) {
        return dispatch(ssoActions.convertUsersRequest(sso, users));
    },
    updateField: function (key, value) {
        return dispatch(ssoActions.updateFieldManagementCurrent(key, value));
    },
    save: function (provider, sso) {
        return dispatch(ssoActions.saveManagementCurrentRequest(provider, sso));
    },
    toggleCompany: function (status, company) {
        return dispatch(ssoActions.toggleCompany(status, company));
    },
    searchCompanies: function (searchString) {
        return dispatch(ssoActions.searchCompaniesRequest(searchString));
    },
    attachCompany: function (sso, company) {
        return dispatch(ssoActions.attachCompanyRequest(sso, company));
    },
    detachCompanyRequest: function (sso, company) {
        return dispatch(ssoActions.detachCompanyRequest(sso, company));
    },
    addDomain: function (sso, domain) {
        return dispatch(ssoActions.addDomainRequest(sso, domain));
    },
    clearManagementModals: function () { return dispatch(ssoActions.clearManagementModals()); },
    clear: function () { return dispatch(ssoActions.clearManagement()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
function reCalcList(props) {
    var contentWidth = 0;
    // Handle files
    var columns = props.items.reduce(function (p, item) {
        Object.keys(item).forEach(function (c) {
            if (!headers.includes(c))
                return p;
            var dataKey = '__' + c.replace(/-/g, '');
            var text = (function (v, c) {
                if (c === 'domains') {
                    return getDomains(item[c]);
                }
                return v;
            })((item[c] || '').toString(), c);
            var length = (0, text_1.calculateStringLength)(text);
            var prevValue = p[dataKey];
            if (prevValue && prevValue < length) {
                p[dataKey] = length;
            }
            else if (!prevValue) {
                p[dataKey] = length;
            }
        });
        return p;
    }, {});
    // Override styles for dynamic classes
    var style = document.getElementById('SSOManagementCompanyListCSS');
    if (style && style.parentNode) {
        style.parentNode.removeChild(style);
    }
    style = document.createElement('style');
    style.id = 'SSOManagementCompanyListCSS';
    document.head && document.head.appendChild(style);
    var sheet = style.sheet;
    contentWidth += 3 * 13;
    Object.keys(columns).forEach(function (className, i) {
        var colwidth = Math.max(8, 4 + columns[className] + 26); // convert to rem
        contentWidth += colwidth;
        sheet.insertRule(".".concat(className) +
            ' {max-width: ' +
            colwidth +
            'px;\n min-width: ' +
            colwidth +
            'px;}', i);
    });
    if (contentWidth !== props.contentWidth) {
        props.setContentWidth(contentWidth);
    }
}
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), react_router_dom_1.withRouter, (0, recompose_1.withState)('attachCompanyIsOpen', 'setAttachCompanyIsOpen', false), (0, recompose_1.withState)('convertUsersIsOpen', 'setConvertUsersIsOpen', 'CLOSED'), (0, recompose_1.withState)('domainsModalIsOpen', 'setDomainsModalIsOpen', false), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('total', 'setTotal', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.withState)('detachCompany', 'setDetachCompany', null), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetchFederation(this.props.match.params.federation);
        this.props.fetchCompanies(this.props.match.params.federation);
        this.props.fetchClients();
        this.props.setItems(this.props.management.companyList.sort(function (a, b) {
            return a.name.localeCompare(b.name);
        }));
        reCalcList(__assign(__assign({}, this.props), { items: this.props.management.companyList }));
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.management.currentSaveStatus === 'FETCHED' &&
            this.props.management.currentSaveStatus !==
                prevProps.management.currentSaveStatus &&
            this.props.management.current &&
            this.props.management.current.provider &&
            this.props.management.current.provider !==
                this.props.match.params.federation) {
            this.props.history.replace("/".concat(this.props.selectedLanguage, "/admin/sso/").concat(this.props.management.current.provider));
        }
        if (this.props.management.currentStatus === 'STANDBY' &&
            prevProps.management.currentStatus === 'STANDBY') {
            this.props.fetchFederation(this.props.match.params.federation);
        }
        if ((this.props.management.attachCompanyStatus === 'FETCHED' &&
            prevProps.management.attachCompanyStatus === 'FETCHING') ||
            (this.props.management.detachCompanyStatus === 'FETCHED' &&
                prevProps.management.detachCompanyStatus === 'FETCHING') ||
            (this.props.management.companyListStatus !== 'STANDBY' &&
                prevProps.management.companyListStatus === 'STANDBY')) {
            this.props.fetchCompanies(this.props.match.params.federation);
        }
        if (this.props.management.clientListStatus === 'STANDBY' &&
            prevProps.management.clientListStatus === 'STANDBY') {
            this.props.fetchClients();
        }
        if (this.props.management.companyList !== prevProps.management.companyList) {
            this.props.setItems(this.props.management.companyList.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            }));
        }
        if (this.props.items !== prevProps.items) {
            reCalcList(this.props);
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var Settings = function (props) { return (React.createElement("div", null,
    React.createElement("table", null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("label", null,
                    (0, translation_1.getLocalization)("sso/management/settings/name"),
                    ":")),
            React.createElement("td", null,
                React.createElement("span", null,
                    React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("sso/management/settings/name/tooltip")) },
                        React.createElement(components_1.TableRowIcon, { className: 'black', icon: 'fa-info', circle: true })))),
            React.createElement("td", null,
                React.createElement(sok_ui_1.TextInput, { value: props.current.name, onChange: function (e) { return props.updateField('name', e.target.value); } }))),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("label", null,
                    (0, translation_1.getLocalization)("sso/management/settings/provider"),
                    ":")),
            React.createElement("td", null,
                React.createElement("span", null,
                    React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("sso/management/settings/provider/tooltip")) },
                        React.createElement(components_1.TableRowIcon, { className: 'black', icon: 'fa-info', circle: true })))),
            React.createElement("td", null,
                React.createElement(sok_ui_1.TextInput, { value: props.current.provider, onChange: function (e) { return props.updateField('provider', e.target.value); } }))),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("label", null,
                    (0, translation_1.getLocalization)("sso/management/settings/client"),
                    ":")),
            React.createElement("td", null,
                React.createElement("span", null,
                    React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("sso/management/settings/client/tooltip")) },
                        React.createElement(components_1.TableRowIcon, { className: 'black', icon: 'fa-info', circle: true })))),
            React.createElement("td", null,
                React.createElement(sok_ui_1.Dropdown2, null,
                    React.createElement(sok_ui_1.TextInput, { readOnly: true, value: props.current.clientId }),
                    React.createElement(sok_ui_1.Dropdown2Menu, null, props.clientList.map(function (x) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () { return props.updateField('clientId', x.clientId); } }, x.clientId)); }))))),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("label", null,
                    (0, translation_1.getLocalization)("sso/management/settings/visibility"),
                    ":")),
            React.createElement("td", null,
                React.createElement("span", null,
                    React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("sso/management/settings/visibility/tooltip")) },
                        React.createElement(components_1.TableRowIcon, { className: 'black', icon: 'fa-info', circle: true })))),
            React.createElement("td", null,
                React.createElement("div", { className: 'visibility' },
                    React.createElement(sok_ui_1.Input, { type: 'radio', label: (0, translation_1.getLocalization)("sso/management/settings/visibility/hide"), value: props.current.visible === false, onClick: function () { return props.updateField('visible', false); } }),
                    React.createElement(sok_ui_1.Input, { type: 'radio', label: (0, translation_1.getLocalization)("sso/management/settings/visibility/show"), value: props.current.visible === true, onClick: function () { return props.updateField('visible', true); } })))),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("label", null,
                    (0, translation_1.getLocalization)("sso/management/settings/policy"),
                    ":")),
            React.createElement("td", null,
                React.createElement("span", null,
                    React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("sso/management/settings/policy/tooltip")) },
                        React.createElement(components_1.TableRowIcon, { className: 'black', icon: 'fa-info', circle: true })))),
            React.createElement("td", null,
                React.createElement(sok_ui_1.Dropdown2, null,
                    React.createElement(sok_ui_1.TextInput, { readOnly: true, value: (0, translation_1.getLocalization)("sso/management/settings/policy/".concat(props.current.policy)) }),
                    React.createElement(sok_ui_1.Dropdown2Menu, null,
                        React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () { return props.updateField('policy', 'SINGLE'); } }, (0, translation_1.getLocalization)("sso/management/settings/policy/SINGLE")),
                        React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () { return props.updateField('policy', 'MULTI'); } }, (0, translation_1.getLocalization)("sso/management/settings/policy/MULTI"))))))),
    React.createElement("div", { className: 'settings-tools' },
        React.createElement(sok_ui_1.Button, { size: 'large', color: 'green', text: (0, translation_1.getLocalization)('buttons/save'), onClick: function () { return props.save(props.provider, props.current); } })))); };
function getColumn(column, value) {
    return (React.createElement("div", { className: classNames("row__column dynamic __".concat(column), column === 'name-meta' && 'expand'), "data-key": "__".concat(column) }, value));
}
var NotFoundPlaceHolder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-files', className: 'no-sso-management-companies' }),
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9'), width: 200, height: 200 }),
    React.createElement("b", null, (0, translation_1.getLocalization)("sso/management/emptyList/title")),
    React.createElement("span", null, (0, translation_1.getLocalization)("sso/management/emptyList/message")))); };
var _createRowData = function (style, items, selectedLanguage, selected, toggleCompany) { return ({
    style: style,
    items: items,
    selectedLanguage: selectedLanguage,
    selected: selected,
    toggleCompany: toggleCompany
}); };
var createRowData = memoize(_createRowData);
var ListRowDataExtractable = Types.extractReturnType(_createRowData);
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var items = data.items, selectedLanguage = data.selectedLanguage, selected = data.selected, toggleCompany = data.toggleCompany;
    var row = items[index];
    var isSelected = selected.indexOf(row.id) > -1;
    return (React.createElement("div", { className: classNames('row'), style: style },
        React.createElement("div", { className: 'row__column narrow icon' },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-check', circle: true, className: isSelected ? 'selected' : null, onClick: function () { return toggleCompany(!isSelected, row); } })),
        getColumn('id', row.id),
        getColumn('name', React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/admin/customermanagement/customer/").concat(row.uuid) }, row.name)),
        getColumn('domains', getDomains(row.domains)),
        React.createElement("div", { className: "row__column narrow" })));
});
exports.default = enhance(function (props) {
    // memoize item props into props.data object
    var itemData = createRowData({}, props.items, props.selectedLanguage, props.management.selectedCompanies, props.toggleCompany);
    return (React.createElement("div", { className: 'content-wrapper-content' },
        React.createElement("div", { className: 'sso-management-view' },
            React.createElement("main", { className: 'content' },
                React.createElement(sok_ui_1.RequestStatusBox, { status: props.management.detachCompanyStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILURE'] },
                    React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/detach/saving')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/detach/saved')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/detach/failed'))),
                React.createElement(sok_ui_1.RequestStatusBox, { status: props.management.currentSaveStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILURE'] },
                    React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/saving')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/saved')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('sso/management/failed'))),
                React.createElement(sok_ui_1.BreadCrumb, null,
                    React.createElement(react_router_dom_1.Link, { to: "/" }, "SokoPro"),
                    React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/system')),
                    React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/admin/sso") }, (0, translation_1.getLocalization)('breadcrumb/ssomanagement')),
                    props.management.current && (React.createElement("span", null, props.management.current.name))),
                React.createElement(sok_ui_1.BoxLayout, { direction: "column" },
                    React.createElement(sok_ui_1.BoxLayout, { direction: props.viewportSize === 'DESKTOP' ? 'row' : 'column' },
                        React.createElement(sok_ui_1.Panel, { icon: React.createElement(sok_ui_1.Icon, { className: 'fa-user' }), title: (0, translation_1.getLocalization)("sso/management/companies"), className: 'panel-sso-companies' },
                            React.createElement("div", { key: 'list', className: 'sok-list-content sso-management-list ' +
                                    props.management.companyListStatus.toLowerCase() },
                                props.management.companyListStatus === 'FAILURE' && (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                                            return props.fetchCompanies(props.match.params.federation);
                                        } }))),
                                props.management.companyListStatus === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'center' },
                                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                                props.management.companyListStatus === 'FETCHED' &&
                                    props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                                    var width = _a.width, height = _a.height;
                                    return (React.createElement(sok_ui_1.List, { key: 'list', itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, placeholder: React.createElement(NotFoundPlaceHolder, { key: 'not-found' }) }, ListRow));
                                })))),
                        React.createElement(sok_ui_1.BoxLayout, { direction: 'column' },
                            React.createElement(sok_ui_1.Panel, { icon: React.createElement(sok_ui_1.Icon, { className: 'fa-wrench' }), title: (0, translation_1.getLocalization)("sso/management/tools") },
                                React.createElement("div", { className: 'tools-container' },
                                    React.createElement(sok_ui_1.Button, { size: 'large', color: 'green', text: (0, translation_1.getLocalization)("sso/management/tools/addCompany"), onClick: function () { return props.setAttachCompanyIsOpen(true); } }),
                                    React.createElement(sok_ui_1.Button, { size: 'large', color: 'dark-gray', text: (0, translation_1.getLocalization)("sso/management/tools/updateDomainsCompany"), onClick: function () { return props.setDomainsModalIsOpen(true); } }),
                                    React.createElement(sok_ui_1.Button, { size: 'large', color: 'red', text: (0, translation_1.getLocalization)("sso/management/tools/removeCompany"), disabled: props.management.selectedCompanies.length !== 1, onClick: function () {
                                            var company = props.management.companyList.find(function (x) {
                                                return props.management.selectedCompanies.includes(x.id);
                                            });
                                            if (props.management.current && company) {
                                                props.setDetachCompany({
                                                    sso: props.management.current,
                                                    company: company
                                                });
                                            }
                                        } }),
                                    React.createElement(sok_ui_1.Button, { size: 'large', color: 'blue', text: (0, translation_1.getLocalization)("sso/management/tools/convertToSSOUsers"), onClick: function () {
                                            return props.setConvertUsersIsOpen('NOT_FEDERATED');
                                        } }),
                                    React.createElement(sok_ui_1.Button, { size: 'large', color: 'blue', text: (0, translation_1.getLocalization)("sso/management/tools/convertToNormalUsers"), onClick: function () { return props.setConvertUsersIsOpen('FEDERATED'); } }))),
                            React.createElement(sok_ui_1.Panel, { icon: React.createElement(sok_ui_1.Icon, { className: 'fa-cog' }), title: (0, translation_1.getLocalization)("sso/management/settings") },
                                React.createElement("div", { className: 'settings-container' },
                                    (props.management.clientListStatus === 'FETCHING' ||
                                        props.management.currentStatus === 'FETCHING') && (React.createElement("div", null,
                                        React.createElement(sok_ui_1.LoadingSpinner, null))),
                                    (props.management.clientListStatus === 'FAILURE' ||
                                        props.management.currentStatus === 'FAILURE') && (React.createElement("div", null, (0, translation_1.getLocalization)('generic/error'))),
                                    props.management.current &&
                                        props.management.currentStatus === 'FETCHED' &&
                                        props.management.clientListStatus === 'FETCHED' && (React.createElement(Settings, { provider: props.match.params.federation, current: props.management.current, clientList: props.management.clientList, updateField: props.updateField, save: props.save })))),
                            React.createElement(sok_ui_1.Panel, { icon: React.createElement(sok_ui_1.Icon, { className: 'fa-analytics', prefix: 'fas' }), title: 'Analytics ?' },
                                React.createElement("div", { className: 'analytics-container' },
                                    React.createElement("div", null, "Total users?"),
                                    React.createElement("div", null, "Active users?"),
                                    React.createElement("div", null, "etc?")))))),
                props.management.current && (React.createElement(AttachCompanyModal_1.AttachCompany, { isOpen: props.attachCompanyIsOpen, setIsOpen: props.setAttachCompanyIsOpen, attachCompany: props.attachCompany, sso: props.management.current, searchCompanies: props.searchCompanies, companySearch: props.management.companySearch, companySearchStatus: props.management.companySearchStatus, attachCompanyStatus: props.management.attachCompanyStatus, clearManagementModals: function () { return props.clearManagementModals(); } })),
                props.management.current && (React.createElement(ManageUsersModal_1.ManageUsersModal, { isOpen: props.convertUsersIsOpen, setIsOpen: props.setConvertUsersIsOpen, fetchUsers: props.fetchUsers, convertUsers: props.convertUsers, sso: props.management.current, listUsers: props.management.listUsers, listUsersStatus: props.management.listUsersStatus, convertUsersStatus: props.management.convertUsersStatus })),
                props.management.current && (React.createElement(DomainsModal_1.DomainsModal, { isOpen: props.domainsModalIsOpen, setIsOpen: props.setDomainsModalIsOpen, sso: props.management.current, addDomain: props.addDomain, addDomainStatus: props.management.addDomainStatus })),
                props.management.current && (React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.detachCompany !== null, close: function () { return props.setDetachCompany(null); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                        React.createElement(ConfirmDialog_1.Exclamation, null),
                        React.createElement("div", null,
                            React.createElement("div", { className: 'title please-confirm-text' },
                                React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                            React.createElement("div", { className: 'text' },
                                React.createElement("p", null, (0, translation_1.getLocalization)('sso/management/detach/company'))))), footer: React.createElement(React.Fragment, null,
                        React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                                if (props.detachCompany) {
                                    props.setDetachCompany(null);
                                    props.detachCompanyRequest(props.detachCompany.sso, props.detachCompany.company);
                                }
                            } }),
                        React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setDetachCompany(null); } })) }))))));
});
